<template>
  <div class="skeleton-message" :class="{ 'skeleton-user': isUser, 'skeleton-support': !isUser }">
    <div v-if="!isUser" class="skeleton-avatar"></div>
    <div v-else class="skeleton-avatar-spacer"></div>
    <div class="skeleton-content">
      <div class="skeleton-bubble">
        <div class="skeleton-line" :style="{ width: line1Width }"></div>
        <div v-if="showSecondLine" class="skeleton-line" :style="{ width: line2Width }"></div>
        <div v-if="showThirdLine" class="skeleton-line" :style="{ width: line3Width }"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessageSkeleton',
  props: {
    isUser: {
      type: Boolean,
      default: false
    },
    showSecondLine: {
      type: Boolean,
      default: true
    },
    showThirdLine: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    line1Width() {
      return `${Math.random() * 40 + 60}%`;
    },
    line2Width() {
      return `${Math.random() * 40 + 50}%`;
    },
    line3Width() {
      return `${Math.random() * 30 + 40}%`;
    }
  }
}
</script>

<style scoped>
.skeleton-message {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  margin-bottom: 12px;
  animation: skeletonPulse 1.5s ease-in-out infinite;
  direction: rtl;
}

.skeleton-user {
  justify-content: flex-end;
  margin-left: auto;
}

.skeleton-support {
  justify-content: flex-start;
}

.skeleton-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  flex-shrink: 0;
}

.skeleton-avatar-spacer {
  width: 32px;
  flex-shrink: 0;
}

.skeleton-content {
  max-width: 75%;
  min-width: 120px;
}

.skeleton-bubble {
  padding: 12px 16px;
  border-radius: 16px;
  background: #f0f0f0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.skeleton-user .skeleton-bubble {
  background: #e8e8e8;
  border-radius: 16px 16px 4px 16px;
}

.skeleton-support .skeleton-bubble {
  border-radius: 16px 16px 16px 4px;
}

.skeleton-line {
  height: 12px;
  background: linear-gradient(90deg, #e0e0e0 25%, #d0d0d0 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  border-radius: 6px;
  animation: skeletonShimmer 1.5s ease-in-out infinite;
}

@keyframes skeletonPulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

@keyframes skeletonShimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>


